import en from './en';
import rw from './rw'
import fr from './fr'

export const translations = {
  en,
  rw,
  fr
};
